<template>
    <transition name="modal">       

        <!-- The Modal -->
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-dialog modal-dialog-scrollable">
                    <div class="modal-content rounded-8">

                        <!-- Modal Header -->
                        <div class="modal-header bg-utel-v2-secondary text-primary">
                            <h4 class="modal-title"><strong>Bloquear usuarios en Plataforma</strong></h4>
                            <button type="button" class="btn"  @click="close">X</button>
                        </div>
                        
                        <!-- Modal body -->
                        <div class="modal-body">
                            <div class="row p-3">
                                <div class="col-12">
                                    <input type="checkbox" v-model="mostrarFiltros"><small> Mostrar filtros</small>
                                </div>
                                <div class="row pb-4" v-if="mostrarFiltros">
                                    <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 py-1">
                                        <small for="">Nombre</small>
                                        <input type="text" v-model="filtro.firstname" placeholder="Ingrese nombre a buscar" class="form-control rounded-8 sin-borde">
                                    </div>
                                    <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 py-1">
                                        <small for="">Apellido</small>
                                        <input type="text" v-model="filtro.lastname" placeholder="Ingrese apellido a buscar" class="form-control rounded-8 sin-borde">
                                    </div>
                                    <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 py-1">
                                        <small for="">Email</small>
                                        <input type="text" v-model="filtro.email" placeholder="Ingrese email a buscar" class="form-control rounded-8 sin-borde">
                                    </div>
                                    <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 py-1">
                                        <small for="">Cargo</small>
                                        <input type="text" v-model="filtro.position" placeholder="Ingrese cargo a buscar" class="form-control rounded-8 sin-borde">
                                    </div>
                                    <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 py-1">
                                        <small for="">Área</small>
                                        <input type="text" v-model="filtro.area" placeholder="Ingrese área a buscar" class="form-control rounded-8 sin-borde">
                                    </div>
                                    <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 py-1">
                                        <small for="">Fecha de creación</small>
                                        <input type="text" v-model="filtro.fecha" placeholder="Ingrese fecha a buscar" class="form-control rounded-8 sin-borde">
                                    </div>
                                    <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 py-1">
                                        <small for=""><br></small>
                                        <button class="btn text-white bg-utel rounded-8" @click.prevent="filtrarBusqueda()">Filtrar</button>
                                        <button class="btn text-white bg-utel rounded-8" @click.prevent="limpiarBusqueda()">Limpiar</button>
                                    </div>
                                </div>                                
                            </div>
                            
                            <!-- Tabla con v-data-table -->
                            <v-data-table
                                :headers="headers"
                                :items="dessertsStudents"
                                :options.sync="options"
                                :items-per-page="options.itemsPerPage"
                                :server-items-length="totalItems"
                                :loading="loading"
                                v-model="selectedStudents"
                                item-value="id"
                                show-select
                                class="elevation-1"
                                hide-default-footer
                            >  
                            
                                <!-- Slot para personalizar columna de selección -->
                                <template v-slot:item.data-table-select="{ item, isSelected, select }">
                                    <input
                                    type="checkbox"
                                    class="form-check-input"
                                    :checked="item.active || isSelected"
                                    @change="select($event.target.checked)"
                                    :disabled="item.active"
                                    :title="item.active ? 'Este usuario ya está en la ruta' : ''"
                                    />
                                </template>

                                <template v-slot:item.created_at_convert_complete="{ item }">
                                    {{ item.created_at_convert_complete }}
                                </template>

                                <template v-slot:footer>
                                    <div class="text-center pt-2">
                                        <v-pagination 
                                            v-model="options.page"
                                            :length="options.pageCount"
                                            :total-visible="6" 
                                            next-icon='fas fa-angle-right'
                                            prev-icon='fas fa-angle-left'
                                        ></v-pagination>
                                    </div>
                                </template>
                            </v-data-table>
                        </div>
                        
                        <!-- Modal footer -->
                        <div class="modal-footer">
                            <button type="button" class="btn text-primary sin-borde bg-utel-v2-secondary mx-3 rounded-8" id="cancel-button-routes" @click="close"
                                aria-label="Close modal" data-dismiss="modal">
                                Cancelar
                            </button>
                            <button type="button" id="generate-button-users" class="btn text-white bg-utel rounded-8" :disabled="btnEnviarDisabled" @click="disableUsers" data-dismiss="modal" v-html="btnTextGuardarCambios"></button>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>        
    </transition>
</template>

<script>
export default {
    props: ['urlstudents'],
    data() {
        return {
            totalItems: 0,
            loading: false,

            // paginación y opciones
            options: {
                page: 1,
                pageCount: 0,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
            },
            dessertsStudents: [],
            selectedStudents : [],
            isCheckedSelectAll: false,
            btnEnviarDisabled: false ,
            btnTextGuardarCambios: 'Deshabilitar',
            mostrarFiltros: false,
            filtro: { firstname: '', lastname: '', email: '', position: '', area: '', fecha: '' },

            headers: [
                { text: 'Nombres', value: 'firstname' },
                { text: 'Apellidos', value: 'lastname' },
                { text: 'Correo', value: 'email' },
                { text: 'Cargo', value: 'position' },
                { text: 'Área', value: 'area' },
                { text: 'Fecha de creación', value: 'created_at_convert_complete' },
            ],
        }
    },
    watch: {
        options: {
            handler() {
                this.getUsers();
            },
            deep: true,
        }
    },
    mounted() {
        this.getUsers();
    },
    methods: {
        close() {
            this.$emit('close');
        },
        reloadTable(){
            this.$emit('reloadtable', true);
        },
        getUsers() {
            this.loading = true;
            let context = this;

            const params = new URLSearchParams(location.search);
            let client = params.get('client');

            let url = this.urlstudents + "?withUsers=true&onlyClient=" + true;

            if(this.filtro.firstname != "" || this.filtro.lastname != "" || this.filtro.email != "" || this.filtro.position != "" || this.filtro.area != "" || this.filtro.fecha != ""){
                url = url+"&firstname="+this.filtro.firstname+"&lastname="+this.filtro.lastname+"&email="+this.filtro.email+"&position="+this.filtro.position+"&area="+this.filtro.area+"&fecha="+this.filtro.fecha;
            }
            url += `&page=${this.options.page}&per_page=${this.options.itemsPerPage}`;

            axios
            .get(
                `${url}&userEnable=true`
            )
            .then((res) => {
                context.dessertsStudents = res.data.data;   // <- asegúrate de que backend devuelva data así
                context.totalItems = res.data.total;        // <- total de registros
                context.options.page = res.data.current_page;
                context.options.pageCount = res.data.last_page;
            });
        },
        async disableUsers() {
            this.btnTextGuardarCambios = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Deshabilitando...`;
            this.btnEnviarDisabled = true;
            
            try {
                const students = this.selectedStudents.map(s => (typeof s === 'object' ? s.id : s));
                const data = { students: students };

                const response = await axios.post("/dashboard/users/disable-users", data);

                // Reset button state
                this.btnEnviarDisabled = false;
                this.btnTextGuardarCambios = "Deshabilitar";

                // Close modal first
                this.$emit('close');
                this.$emit('reloadtable', true);
                
                // Wait for modal to close, then show success message
                setTimeout(async () => {
                    const message = response.data.message || 'Usuarios deshabilitados exitosamente';
                    
                    await this.$swal({
                        icon: 'success',
                        title: '¡Éxito!',
                        text: message,
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: '#1A0054',
                        background: '#ffffff',
                        color: '#1A0054'
                    });
                }, 300);
                
                this.selectedStudents = [];
            } catch (error) {
                console.error('Error disabling users:', error);
                
                // Reset button state
                this.btnEnviarDisabled = false;
                this.btnTextGuardarCambios = "Deshabilitar";
                
                // Show error message
                const errorMessage = error.response?.data?.message || 'Error al deshabilitar usuarios';
                
                await this.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: errorMessage,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#1A0054',
                    background: '#ffffff',
                    color: '#1A0054'
                });
            }
        },
        disableButton(isTrue) {
            if(isTrue){
                document.getElementById("generate-button-users").setAttribute("disabled", "");
            }else{
                document.getElementById("generate-button-users").removeAttribute("disabled");
            }
        },
        selectAll(){
            let context = this;
            context.selectedStudents = [];
            let ids = document.getElementsByClassName("inputUser");
            for(let i=0;i<ids.length;i++){
                if((context.isCheckedSelectAll && ids[i].disabled == false) || (ids[i].disabled && ids[i].checked)){
                    context.selectedStudents.push(ids[i].value);
                }
            }
            if(context.isCheckedSelectAll) context.btnEnviarDisabled = false;
        },
        filtrarBusqueda(){
            this.isCheckedSelectAll = false;
            this.selectedStudents = [];
            this.options.page = 1;
            this.getUsers();
        },
        limpiarBusqueda(){
            Object.keys(this.filtro).forEach(k => this.filtro[k] = '');
            this.selectedStudents = [];
            this.options.page = 1;
            this.options.pageCount = 0;
            this.getUsers();
        },
        toggleUser(id, checked) {
            if (checked && !this.selectedStudents.includes(id)) {
            this.selectedStudents.push(id);
            } else if (!checked) {
            this.selectedStudents = this.selectedStudents.filter(s => s !== id);
            }
        },
        toggleSelectAll(pageItems, checked) {
            if (checked) {
                // Agregar los ids de la página actual a los globales
                pageItems.forEach(u => {
                if (!this.selectedStudents.includes(u.id)) {
                    this.selectedStudents.push(u.id);
                }
                });
            } else {
                // Quitar los ids de la página actual
                this.selectedStudents = this.selectedStudents.filter(
                id => !pageItems.some(u => u.id === id)
                );
            }
        }
    },
};
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  /*display: table;*/
  transition: opacity .3s ease;
}

.modal-wrapper {
  /*display: table-cell;*/
  vertical-align: middle;
}

.modal-dialog-scrollable .modal-body {
    max-height: 78vh;
}
</style>
